import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjsLocal from 'dayjs/locale/en-sg';

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.locale(dayjsLocal);

export default dayjs;
